import { Button, Stack, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "react-toastify";

import _Cancelamento from "@/assets/images/Data_Cancelamento.svg";
import { useSession } from "@/hooks/@custom/useSession";
import { useGetDriverQueueLeaveStatusQuery, useGetQueueDriverPositionQuery, useSaveQueueDeleteMutation } from "@/store/apis/nextcargo";

export function DriverLeaveQueueModal({ id, context }: ContextModalProps) {
  const { driver } = useSession();
  const driverId = String(driver?.id);
  const navigate = useNavigate();

  const [saveQueueDeleteTrigger, { isLoading: isLoadingSaveQueueDelete }] = useSaveQueueDeleteMutation({ fixedCacheKey: "delete-queue" });
  const { data: driverQueuePosition, isLoading: isLoadingDriverQueuePosition } = useGetQueueDriverPositionQuery({ id: Number(driverId) }, { skip: !driverId });
  const { data: driverQueueLeaveStatus, isLoading: isLoadingDriverQueueLeaveStatus } = useGetDriverQueueLeaveStatusQuery(
    { id: Number(driverId) },
    { skip: !driverId, pollingInterval: 1000 * 30 }
  );

  const isLoading = isLoadingSaveQueueDelete || isLoadingDriverQueuePosition || isLoadingDriverQueueLeaveStatus;
  const driverQueueId = driverQueuePosition?.queue.id;

  const handleCloseModal = () => {
    context.closeModal(id);
  };

  async function handleConfirmRemove() {
    if (!driverQueuePosition?.queue) return;

    if (!driverQueueLeaveStatus?.canLeave) {
      toast.error("Você está próximo de ser atendido. Não é possível sair da fila neste momento.");
      handleCloseModal();
      return;
    }

    const { error } = await saveQueueDeleteTrigger({ id: driverQueueId! });
    if (!error) {
      navigate({ to: "/app" });
    }
    handleCloseModal();
  }

  return (
    <Stack gap="md" align="center" justify="center">
      <img src={_Cancelamento} className="size-2/4" />

      <Stack>
        <Title order={1} ta="center" c="white">
          Deseja <strong>cancelar</strong> a marcação?
        </Title>

        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
          <Button onClick={handleCloseModal} variant="outline" color="white" disabled={isLoading}>
            Não
          </Button>

          <Button onClick={handleConfirmRemove} variant="outline" color="white" loading={isLoading}>
            Sim
          </Button>
        </div>
      </Stack>
    </Stack>
  );
}
